var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCode = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-0f53e7b8-6a58-46c3-85ca-f55403863384",
    "data-name": "Layer 2",
    viewBox: "0 0 32.66 25.45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2bfe359c-22c0-4934-b111-02f43bcc7284 {\n        fill: #00cc7a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-c0e3fcdf-72a0-4406-820f-e6471ece1910",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-2bfe359c-22c0-4934-b111-02f43bcc7284",
    d: "m8.6,19.6c0,1.51.92,1.6,1.74,1.68,1.66.18,2.16,1.12,2.16,2.07,0,1-.53,2.1-2.66,2.1-3.31,0-5.7-2.63-5.7-5.82v-3.34c0-1.18-.86-1.71-1.71-1.71h-.21c-1.45,0-2.22-1.03-2.22-2.07s.77-2.16,2.22-2.16h.21c.86,0,1.71-.47,1.71-1.66v-2.84C4.14,2.63,6.53,0,9.84,0c2.13,0,2.66,1.12,2.66,2.1,0,.86-.44,1.92-2.16,2.07-.83.09-1.74.18-1.74,1.71v2.72c0,1.51-.86,2.96-1.92,3.93v.06c1.06.95,1.92,2.36,1.92,3.81v3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2bfe359c-22c0-4934-b111-02f43bcc7284",
    d: "m24.03,16.4c0-1.45.86-2.87,1.92-3.81v-.06c-1.06-.98-1.92-2.42-1.92-3.93v-2.72c0-1.54-.89-1.63-1.74-1.71-1.68-.15-2.16-1.21-2.16-2.07,0-.98.56-2.1,2.63-2.1,3.34,0,5.73,2.63,5.73,5.85v2.84c0,1.18.86,1.66,1.71,1.66h.24c1.45,0,2.22,1.12,2.22,2.16s-.77,2.07-2.22,2.07h-.24c-.86,0-1.71.53-1.71,1.71v3.34c0,3.19-2.39,5.82-5.73,5.82-2.07,0-2.63-1.09-2.63-2.1,0-.95.56-1.89,2.16-2.07.86-.09,1.74-.18,1.74-1.68v-3.19Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/code.21a2c4ac.svg";
export { ForwardRef as ReactComponent };